import { FiSearch, FiX } from 'react-icons/fi';
import { FILTERS, ACTIONS } from '../../constants/labels';
import { RECEIPT_TYPE_LABEL } from './receiptsConfig';
import styles from './Receipts.module.css';

export default function ReceiptsFilters({
  years,
  filterYear, filterType, filterDonor, filterFromDate, filterToDate,
  minDate, maxDate, onYearChange, onTypeChange, onDonorChange, onFromDateChange, onToDateChange,
  onClearFilters,
}) {
  return (
    <div className={styles.filterRow}>
      <div className="form-group">
        <label>{FILTERS.allYears.replace('All ', '')}</label>
        <select value={filterYear} onChange={(e) => onYearChange(e.target.value)}>
          <option value="">{FILTERS.allYears}</option>
          {years.map((y) => <option key={y.id} value={y.id}>{y.yearLabel}</option>)}
        </select>
      </div>

      <div className="form-group">
        <label>Type</label>
        <select value={filterType} onChange={(e) => onTypeChange(e.target.value)}>
          <option value="">{FILTERS.allTypes}</option>
          {Object.entries(RECEIPT_TYPE_LABEL).map(([val, label]) => (
            <option key={val} value={val}>{label}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>{FILTERS.donorName}</label>
        <div style={{ position: 'relative' }}>
          <FiSearch style={{
            position: 'absolute', left: 9, top: '50%',
            transform: 'translateY(-50%)',
            color: 'var(--color-text-muted)', pointerEvents: 'none',
          }} />
          <input
            value={filterDonor}
            onChange={(e) => onDonorChange(e.target.value)}
            placeholder="Search donor…"
            style={{ paddingLeft: 30 }}
          />
        </div>
      </div>

      <div className="form-group">
        <label>From Date</label>
        <input
          type="date"
          value={filterFromDate}
          min={minDate || undefined}
          max={filterToDate || maxDate || undefined}
          onChange={(e) => onFromDateChange(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>To Date</label>
        <input
          type="date"
          value={filterToDate}
          min={filterFromDate || minDate || undefined}
          max={maxDate || undefined}
          onChange={(e) => onToDateChange(e.target.value)}
        />
      </div>

      <div className="form-group" style={{ alignSelf: 'flex-end' }}>
        <button className="btn btn-ghost btn-sm" onClick={onClearFilters} title={ACTIONS.clearFilters}>
          <FiX /> {ACTIONS.clearFilters}
        </button>
      </div>
    </div>
  );
}
